// extracted by mini-css-extract-plugin
export default {"list__container":"style_list__container__2dVZB","searching":"style_searching__N8Lr5","title":"style_title__DvXCV"};